<template>
  <div class="top-panel">
    <search-input />

    <user-panel />
  </div>
</template>

<script>
import UserPanel from './UserPanel.vue';
import SearchInput from './SearchInput.vue';

export default {
  name: 'top-panel',

  components: {
    UserPanel,
    SearchInput,
  },
};
</script>

<style lang="scss" scoped>
.top-panel {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--white-color);
  box-sizing: border-box;
  padding: 0 20px;
  z-index: 99;
  position: relative;
  border-bottom: 1px solid var(--light-grey-color);
}
</style>
